import {Injectable} from '@angular/core';
import {webapi} from '../../shared/my-constants';
import {Headers, Http, Response} from '@angular/http';

@Injectable()
export class DischargeService {
  private GetBasepath = webapi + 'mst_patient/getbasepath/';
  private ListRecord = webapi + 'trn_discharge/list/?';
  private AddRecord = webapi + 'trn_discharge/create';
  private EditRecord = webapi + 'trn_discharge/update';
  private GetRecord = webapi + 'trn_discharge/byid/';
  private GetRecordbyadmissionid = webapi + 'trn_discharge/admissionbyid/';
  private DeleteRecord = webapi + 'trn_discharge/delete/';
  private getbilltecordservice = webapi + 'trn_discharge/finalbillchack/';
  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(private http: Http) {
  }

  gatbasepath() {
    return this.http.get(this.GetBasepath)
      .toPromise()
      .then(response => response as any)
      .catch(this.handleError);
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  checkfinalbillService(admissionid: any) {
    return this.http.get(this.getbilltecordservice + admissionid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordServicebyadmissionid(id: any) {
    return this.http.get(this.GetRecordbyadmissionid + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/discharge/discharge.service.ts